<template>
  <TheModal :show="show" size="lg" @close="onClose">
    <article v-if="guide" class="product-guide">
      <h2 class="product-guide__title h4 mb-2">{{ guide.title }}</h2>
      <p v-if="guide.lead" class="product-guide__lead text-muted mb-4">{{ guide.lead }}</p>
      <ol v-if="guide.steps?.length" class="product-guide__steps">
        <li v-for="(step, index) in guide.steps" :key="index" class="product-guide__step">
          <h3 class="product-guide__step-title h6 mb-1">{{ step.title }}</h3>
          <p class="product-guide__step-text text-muted small mb-0">{{ step.text }}</p>
        </li>
      </ol>
      <ul v-if="guide.tips?.length" class="product-guide__tips small text-muted mb-0 ps-3">
        <li v-for="(tip, index) in guide.tips" :key="'tip-' + index">{{ tip }}</li>
      </ul>
      <div class="product-guide__actions d-flex justify-content-end mt-4">
        <button type="button" class="btn btn-primary" @click="$emit('confirm')">
          {{ guide.ctaLabel || 'Понятно' }}
        </button>
      </div>
    </article>
  </TheModal>
</template>

<script setup>
import { computed } from 'vue'
import TheModal from '@/components/TheModal.vue'
import { getProductGuide } from '@/constants/productGuides'

const props = defineProps({
  show: { type: Boolean, default: false },
  guideId: { type: String, default: '' },
})

const emit = defineEmits(['confirm', 'dismiss'])

const guide = computed(() => getProductGuide(props.guideId))

function onClose() {
  emit('dismiss')
}
</script>

<style scoped>
.product-guide__steps {
  list-style: none;
  padding: 0;
  margin: 0 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.product-guide__step {
  padding-left: 2.5rem;
  position: relative;
  counter-increment: guide-step;
}

.product-guide__steps {
  counter-reset: guide-step;
}

.product-guide__step::before {
  content: counter(guide-step);
  position: absolute;
  left: 0;
  top: 0;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background: var(--bs-primary-bg-subtle, #e8f0fe);
  color: var(--bs-primary, #1161ee);
  font-size: 0.875rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-guide__tips {
  margin-top: 1rem;
}
</style>
